import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    shiftAdditionalNavOption,
    setCallToDisplay,
} from "../redux/actions";
import navInfo, { portfolioSubNav } from "../helpers/navInfo";
import scrollUp from "../helpers/scrollUp";

if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

const baseOptions = navInfo.filter(option => option.baseOption && !option.fallback)
const additionalOptions = navInfo.filter(option => !option.baseOption)
const defaultOption = navInfo.find(option => option.baseOption)

const useURLController = () => {
    const [scaledOpacity, setScaledOpacity] = useState(0);
    const [initialPath, setInitialPath] = useState(null)
    const dispatch = useDispatch();
    const settings = useSelector((state) => state.settings);

    useEffect(() => {
        scrollUp()
        const casedLocation = window.location.pathname.toLowerCase();
        const foundBaseOption = baseOptions.find(option => option.path === casedLocation);
        if (foundBaseOption) {
            setInitialPath(foundBaseOption.path.substring(1));
            return dispatch(setCallToDisplay(foundBaseOption.navName));
        }

        const foundAdditionalOption = additionalOptions.find(option => option.path === casedLocation);
        if (foundAdditionalOption) {
            dispatch(shiftAdditionalNavOption(foundAdditionalOption.navName));
            dispatch(setCallToDisplay(foundAdditionalOption.navName));
            return setInitialPath(foundAdditionalOption.path.substring(1));
        }
        const foundPortfolioOption = portfolioSubNav.find(option => option.path === casedLocation);
        if (foundPortfolioOption) {
            setInitialPath(foundPortfolioOption.path.substring(1));
            return dispatch(setCallToDisplay(foundPortfolioOption.navName));
        }
        setInitialPath(defaultOption.altPath.substring(1));
        dispatch(setCallToDisplay("ABOUT"));
        window.history.pushState({}, "", "/");
    }, []);

    useEffect(()=>{
        const manageNavigation = () => {
            const casedLocation = window.location.pathname.toLowerCase();
            const foundOption = navInfo.find(option => option.path === casedLocation || option.altPath === casedLocation);
            if (!foundOption) {
                return console.log("ISSUE FINDING NAVIGATION OPTION")
            }
            // setScaledOpacity(0);
            dispatch(setCallToDisplay(foundOption.navName))
        }
        // manageNavigation()
        window.addEventListener("popstate",manageNavigation);
        return () => {
          window.removeEventListener("popstate", manageNavigation);
        };
    }, [window.history])

    return {scaledOpacity, setScaledOpacity, initialPath};
};
export default useURLController;
